import Axios from 'axios'
import config from './config'
import cookie from './cookie'
import { Message } from 'view-design'

export const baseUrl = config.baseUrl

let axios = Axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    if (cookie.getToken()) {
      config.headers['x-access-token'] = cookie.getToken()
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  res => {
    return validateResponseCode(res)
  },
  error => {
    Message.error('服务内部错误')
    return Promise.reject(error)
  }
)

function validateResponseCode (res) {
  let { data } = res
  return Promise.resolve(data)
}

export const getAxios = (url, data) => {
  return axios.get(url, {
    params: data
  })
}

export const postAxios = (url, data) => {
  return axios.post(url, data)
}

export const postFileUploadAxios = (url, data) => {
  const form = new FormData()
  form.append('file', data)
  return axios.post(url, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const postOrderFileUploadAxios = (url, data, order) => {
  const form = new FormData()
  form.append('file', data)
  form.append('order', order)
  return axios.post(url, form, { headers: { 'Content-Type': 'multipart/form-data' } })
}

export const getDownloadAxios = (url) => {
  return axios.get(url, { responseType: 'blob' })
}

export const postDownloadAxios = (url, data) => {
  return axios.post(url, data, { responseType: 'blob' })
}



// WEBPACK FOOTER //
// ./src/components/common/http.js